import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { accountingFormData, accountingHeaderData } from "../../forms/AccountingForm";

import "../../assets/styles/accounting/addDocument.scss";
import { AccountingForm } from "../../components/Factor/components";
import { useDispatch } from "react-redux";
import { resetAccounting } from "../../store/actions/formAction";
import { Container } from "@mui/material";
import { apiGetBranches } from "api/branchApi";
import { store } from "store/store";
import { apiGetProjects } from "api/projectApi";

export default function Accounting() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("accounting");
  const {getState}=store
  const Token = getState().businessReducer.business?.token;


  useEffect(() => {
    if (!id) {
      dispatch(resetAccounting());
    }
  }, []);
useEffect(() => {
  dispatch(apiGetBranches(Token))
  dispatch(apiGetProjects(Token))
  return () => {
    
  }
}, [])

  return (
    <Container maxWidth="lg">
      <div className="wrap-factor">
        <AccountingForm
          form={accountingFormData}
          accountingId={id}
          header={accountingHeaderData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          displayHeader={true}
        />
      </div>
    </Container>
  );
}
